function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  background-color: #fff0f0; // 연한 빨간색 배경\n  color: #d8000c; // 어두운 빨간색 텍스트\n  border: 1px solid #ffd2d2; // 연한 빨간색 테두리\n  padding: 15px;\n  margin: 20px 0; // 상하 마진\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between; // 내용을 양쪽으로 분산 (아이콘/텍스트와 버튼)\n  gap: 10px; // 아이콘과 텍스트 간격\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 10px;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  background-color: #d8000c; // 에러 메시지와 동일한 색상\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 5px 10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.875rem;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background-color: #b20009; // 약간 더 어두운 색상\n  }\n\n  &:disabled {\n    background-color: #f5c6cb; // 연한 색상\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
// Fixed import to use main lucide-react package to resolve TDZ initialization issues
import { AlertTriangle, RotateCw } from 'lucide-react';
var ErrorContainer = styled.div(_templateObject());
var ErrorContent = styled.div(_templateObject1());
// Avoid TDZ issues by using regular component instead of styled component
var ErrorIcon = function(param) {
    var size = param.size;
    return /*#__PURE__*/ React.createElement(AlertTriangle, {
        size: size,
        style: {
            flexShrink: 0
        }
    });
};
// 재시도 버튼 스타일 추가
var RetryButton = styled.button(_templateObject2());
var ErrorDisplay = function(param) {
    var message = param.message, onRetry = param.onRetry, retryLabel // 기본값 제거 - 사용하는 곳에서 번역된 텍스트 전달
     = param.retryLabel;
    if (!message) {
        return null; // 메시지가 없으면 아무것도 렌더링하지 않음
    }
    return /*#__PURE__*/ React.createElement(ErrorContainer, {
        role: "alert"
    }, /*#__PURE__*/ React.createElement(ErrorContent, null, /*#__PURE__*/ React.createElement(ErrorIcon, {
        size: 20
    }), /*#__PURE__*/ React.createElement("span", null, message)), onRetry && /*#__PURE__*/ React.createElement(RetryButton, {
        onClick: onRetry
    }, /*#__PURE__*/ React.createElement(RotateCw, {
        size: 14
    }), retryLabel));
};
export default ErrorDisplay;
